import type { Candidate } from '@core/types';

/**
 * Synthetic resume-shaped text so Single Optimize's jdAnalysis zones
 * (Experience / Skills / Summary) receive usable structure when we only
 * have CRM fields — not the original file.
 */
export function buildCandidateResumeText(c: Candidate): string {
  const skills = (c.parsed_skills ?? []).filter(Boolean).join(', ');
  const edu =
    (c.education ?? [])
      .map((e) => [e.degree, e.institution, e.year != null ? String(e.year) : ''].filter(Boolean).join(' — '))
      .join('\n') || '';

  const headline = [c.current_title, c.current_company, c.location].filter(Boolean).join(' · ');
  const summaryBits = [headline, c.notes].filter(Boolean).join('\n');

  const lines = [
    c.full_name,
    c.email ? `Email: ${c.email}` : '',
    c.phone ? `Phone: ${c.phone}` : '',
    c.linkedin_url ? `LinkedIn: ${c.linkedin_url}` : '',
    '',
    'Professional summary',
    summaryBits || 'Profile from talent pool record.',
    '',
    'Work experience',
    `• ${c.current_title || 'Professional'} at ${c.current_company || 'Organization'}${c.years_exp != null ? ` — ${c.years_exp}+ years experience` : ''}${skills ? `. Technologies and skills: ${skills}.` : '.'}`,
    '',
    'Skills',
    skills || '(No parsed skills — add skills on the candidate record for tighter match.)',
    '',
    'Education',
    edu || '(Not specified)',
  ];

  return lines.join('\n');
}
